import { render, staticRenderFns } from "./TopicDomainStat.vue?vue&type=template&id=6aeb8ee4&scoped=true&"
import script from "./TopicDomainStat.vue?vue&type=script&lang=js&"
export * from "./TopicDomainStat.vue?vue&type=script&lang=js&"
import style0 from "./TopicDomainStat.vue?vue&type=style&index=0&id=6aeb8ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aeb8ee4",
  null
  
)

export default component.exports